/**
 * Temporary UI-review entry. Keeping this in one place makes restoring the
 * normal registration destination a single, explicit change.
 */
export const productEntry = "/app"

export const productPreviewRoutes = ["/app"] as const

export function isProductPreviewPath(pathname: string): boolean {
  const normalized = pathname.replace(/\/$/, "") || "/"

  return productPreviewRoutes.some(
    (route) => normalized === route || normalized.startsWith(`${route}/`),
  )
}
